var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTaskUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5453",
    "data-name": "Group 5453",
    transform: "translate(-2032 -676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M19.99,2A2,2,0,0,0,18,0H2A2.006,2.006,0,0,0,0,2V14a2.006,2.006,0,0,0,2,2H16l4,4Z",
    transform: "translate(2042 686)",
    fill: "#008001"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTaskUnread);
export default __webpack_public_path__ + "static/media/my_task_unread.b54e6bd3c7cdc8bf0b1c3f0addc112d1.svg";
export { ForwardRef as ReactComponent };